import Joi from '@hapi/joi';

export const maternityLeaveSchema = {
    groupID: Joi.number().invalid(0).required().label('Group').messages({
        'any.invalid': 'Group required',
        'any.required': 'Group required',
        'number.base': 'Group required'
    }),
    operationEntityID: Joi.number().invalid(0).required().label('Operation Entity').messages({
        'any.invalid': 'Operation Entity required',
        'any.required': 'Operation Entity required',
        'number.base': 'Operation Entity required'
    }),
    collectionPointID: Joi.number().invalid(0).required().label('Collection Point').messages({
        'any.invalid': 'Collection Point required',
        'any.required': 'Collection Point required',
        'number.base': 'Collection Point required'
    }),
    registrationNumber: Joi.string().invalid().required().label('Registration Number').messages({
        'any.invalid': 'Registration Number required',
        'any.required': 'Registration Number required'
    }),
    leaveType: Joi.number().invalid(0).required().label('Leave Type').messages({
        'any.invalid': 'Leave Type required',
        'any.required': 'Leave Type required',
        'number.base': 'Leave Type required'
    }),
    fromDate: Joi.date().required().label('From Date').messages({
        'date.base': 'From Date required',
        'any.required': 'From Date required',
        'date.empty': 'From Date required'
    }),
    dayCount: Joi.number().min(1).max(84).required().label('Number of Days').messages({
        'number.base': 'Number of Days required',
        'number.min': 'Number of Days must be at least 1',
        'number.max': 'Number of Days cannot exceed 84',
        'any.required': 'Number of Days required'
    }),
    toDate: Joi.date().required().label('To Date')
};